import React from 'react';
import PropTypes from 'prop-types';

const LinkButton = ({ title, url, ...rest }) => {
  const { className } = rest;

  return (
    <a
      className={`btn ${className || ''}`}
      href={url}
    >
      {title}
    </a>
  );
};

LinkButton.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default LinkButton;
